<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-travel-orders'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-travel-orders"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="getFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :empty-text="$t('No matching records found')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>

          <template #cell(travel)="data">
            <div class="d-flex flex-column">
              <div class="d-flex">
                <span class="width-5 text-right"> {{ $t("Travel") }}: </span>
                <span class="ml-1 text-primary">
                  {{ data.item.travel }}
                </span>
              </div>

              <div class="d-flex">
                <span class="width-5 text-right"> {{ $t("Modality") }}: </span>
                <span class="ml-1">
                  <tabler-icon
                    :class="
                      data.item.modality == 'One Way'
                        ? 'text-warning'
                        : 'text-info'
                    "
                    :icon="
                      data.item.modality == 'One Way'
                        ? 'ArrowUpIcon'
                        : 'SwitchVerticalIcon'
                    "
                  />
                  {{ $t(data.item.modality) }}
                </span>
              </div>
            </div>
          </template>

          <template #cell(vehicle)="data">
            <div class="d-flex flex-column">
              <div class="d-flex">
                <span class="width-5 text-right"> {{ $t("Vehicle") }}: </span>
                <span class="ml-1 text-warning">
                  <tabler-icon icon="TruckIcon" /> {{ data.item.vehicle }}
                </span>
              </div>

              <div class="d-flex" v-if="data.item.trailer_id != null">
                <span class="width-5 text-right"> {{ $t("Trailer") }}: </span>
                <span class="ml-1 text-info"> {{ data.item.trailer }} </span>
              </div>
            </div>
          </template>

          <template #cell(travel_date)="data">
            <div>
              <tabler-icon icon="CalendarIcon" class="text-success" />
              <span> {{ data.item.travel_date | myGlobal }} </span>
            </div>
          </template>

          <template #cell(count_services)="data">
            <div>
              <h4>
                <b-badge
                  :variant="
                    data.item.count_services > 0
                      ? 'light-primary'
                      : isDarkSkin
                      ? 'dark'
                      : 'light-dark'
                  "
                >
                  {{ data.item.count_services }}
                </b-badge>
              </h4>
            </div>
          </template>

          <template #cell(count_documents)="data">
            <div>
              <h4>
                <b-badge
                  :variant="
                    data.item.count_documents > 0
                      ? 'light-primary'
                      : isDarkSkin
                      ? 'dark'
                      : 'light-dark'
                  "
                  :class="{ 'cursor-pointer': data.item.count_documents > 0 }"
                  @click="viewDocumentOrders(data.item.id, 'travel')"
                >
                  {{ data.item.count_documents }}
                </b-badge>
              </h4>
            </div>
          </template>

          <template #cell(status)="data">
            <div>
              <b-badge :variant="resolveStyleTravelStatus(data.item.status)">
                {{ $t(data.item.status) }}
              </b-badge>
            </div>
          </template>

          <template #cell(created_by)="data">
            <div class="d-flex flex-column">
              <span>
                <tabler-icon icon="UserIcon" class="text-primary" />
                {{ data.item.created_name }}
              </span>
              <span style="opacity: 0.8">
                <tabler-icon icon="CalendarIcon" class="text-success" />
                {{ data.item.created_at | myGlobalDay }}
              </span>
            </div>
          </template>
          <template #cell(actions)="data">
            <!-- Edit travel -->
            <feather-icon
              icon="EditIcon"
              size="18"
              v-b-tooltip.hover.v-warning
              :title="$t('Edit travel')"
              class="text-warning cursor-pointer"
              @click="editTravelOrder(data.item)"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <TravelOrderModal
      v-if="modalTravel"
      :travelId="travelId"
      @refreshTable="
        modalTravel = false;
        $refs['ref-table-travel-orders'].refresh();
      "
      @hideModal="modalTravel = false"
    />

    <OrdersDetailModal
      v-if="modalOrdersDetail"
      :id="orderId"
      :type="orderType"
      @hideModal="modalOrdersDetail = false"
    />
  </div>
</template>

<script>
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import Fields from "@/views/operations/views/travel-orders/data/fields.data.js";
import Fiters from "@/views/operations/views/travel-orders/data/filters.data.js";

import TravelOrdersService from "@/views/operations/views/travel-orders/services/travel-orders.service.js";
import TravelOrderModal from "@/views/operations/views/travel-orders/components/modals/TravelOrderModal.vue";
import OrdersDetailModal from "@/views/operations/views/travel-orders/components/modals/OrdersDetailModal.vue";

export default {
  components: {
    FilterSlot,
    TravelOrderModal,
    OrdersDetailModal,
  },
  data() {
    return {
      filters: [],
      fields: Fields,
      isBusy: false,
      sortBy: "",
      sortDesc: true,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      travelId: null,
      modalTravel: false,
      orderId: null,
      orderType: null,
      modalOrdersDetail: false,
    };
  },
  created() {},
  computed: {
    getFields() {
      return this.fields.filter((f) => f.visible);
    },
  },
  methods: {
    async myProvider(ctx) {
      this.addPreloader();
      try {
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          order: 1,
          orderby: ctx.sortDesc ? "Desc" : "Asc",
          search_txt: this.filterPrincipal.model,
          status: 1,
          from: null,
          to: null,
        };

        const { data } = await TravelOrdersService.getTravelOrders(params);
        console.log(data);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;

        return data.data;
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },

    createTravel() {
      this.travelId = null;
      this.modalTravel = true;
    },

    editTravelOrder(item) {
      this.travelId = item.id;
      this.modalTravel = true;
    },

    viewDocumentOrders(id, type) {
      this.orderId = id;
      this.orderType = type;
      this.modalOrdersDetail = true;
    },

    resolveStyleTravelStatus(status) {
      let style = "light-default";
      switch (status) {
        case "Registered":
          style = "light-dark";
          break;
        case "Initiated":
          style = "light-success";
          break;
        case "Returning":
          style = "light-warning";
          break;
        case "Returned":
          style = "light-info";
          break;
        case "Finished":
          style = "light-primary";
          break;
        default:
          break;
      }
      return style;
    },
  },
};
</script>

<style>
.width-5 {
  width: 70px;
}
</style>